import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveUserListService extends BaseService {
  /*********************Properties*********************/

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(protected http: HttpClient, private cache: CacheResolverService,
    private storage: SessionStorageService) {
    super(http);
  }

  get(shipTo = null) {
    // const url = super.serviceUrl(
    //   this.userUrl, UserApi.GetNuctracGroups
    // );
    let requestedUrl = '';
    const url =this.apiConfig.util+ '/api/userManagement/users';

    return super.fetch(url, { params: { onlyActiveUsers: 'Y' } }).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          this.cache.set(CacheConstant.LocalStorage.ActiveUsersList, response.data);
        }
        return response;
      })
    );
  }

  getUserFirstName(id: any) {
    let users = [];
    users = this.cache.get(CacheConstant.LocalStorage.ActiveUsersList);
    return users && users.find(x => x.id === id) ? users.find(x => x.id === id).firstName : '';

  }

}
